import * as Header from '../components/header';

/**
 * @param {*} nodeElement - every possible html element
 * @param {*} substractOrAdditionToScrollOffset - pixels that should be added or substracted from final offsetTop
 * @param {*} scrollingTime - default 900 ms
 */
export function scrollToTarget(nodeElement, substractOrAdditionToScrollOffset = 0, scrollingTime = 900) {
    if (!nodeElement) return;

    const targetOffset = calculateOffsetTop(nodeElement);
    animateScrolling(targetOffset + substractOrAdditionToScrollOffset, scrollingTime);
}

export function scrollToAnchor(e, link) {
    const exludedLinks = ['#easy-popup-', '#skipNavigation', '#ccSkipContent'];

    if (!link.hash || link.dataset?.fslightbox || exludedLinks.some((value) => link.hash.startsWith(value))) {
        return;
    }

    const target = document.querySelector(link.hash);

    if (!location.pathname.includes(link.pathname) || !target) return;

    if (e) e.preventDefault();
    scrollToTarget(target);
}

export function isInViewport(element) {
    const rect = element.getBoundingClientRect();

    return (
        rect.top >= Header.getInnerHeight() &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth
    );
}

function calculateOffsetTop(target) {
    const targetStyles = getComputedStyle(target);

    let marginTop = Number.parseInt(targetStyles.marginTop) / 2;
    marginTop = marginTop < 0 ? 0 : marginTop;

    const endScrollOffset = target.getBoundingClientRect().top + document.documentElement.scrollTop;

    const headerHeight = endScrollOffset > Header.getFixedPosition() ? Header.getInnerHeight() : 0;

    return endScrollOffset - headerHeight - marginTop + 1;
}

/* Eigene Animation statt behavior: 'smooth', weil der Browser dessen Tempo vorgibt (Chrome ist deutlich
 * schneller als die gewünschten ~900 ms für einen Bildschirm). Die Dauer skaliert mit dem Weg, damit kurze
 * Sprünge nicht zäh wirken. Nutzereingaben brechen die Animation ab, damit sie nicht gegen den Nutzer scrollt. */
const REFERENCE_DISTANCE = 600;
const MIN_DURATION = 300;
const CANCEL_EVENTS = ['wheel', 'touchmove', 'keydown'];

let activeFrame = 0;
let cancelActive = () => {};

function animateScrolling(targetOffset, scrollingTime) {
    cancelActive();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo({ top: targetOffset, behavior: 'instant' });

        return;
    }

    const start = window.scrollY;
    const distance = targetOffset - start;

    if (Math.abs(distance) < 1) return;

    const duration = Math.max(MIN_DURATION, Math.min(scrollingTime, (Math.abs(distance) / REFERENCE_DISTANCE) * scrollingTime));
    const startTime = performance.now();
    const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2);

    const cleanup = () => {
        cancelAnimationFrame(activeFrame);
        for (const type of CANCEL_EVENTS) window.removeEventListener(type, cleanup);
        cancelActive = () => {};
    };

    const step = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        // 'instant', sonst animiert das CSS scroll-behavior: smooth jeden einzelnen Schritt nochmal
        window.scrollTo({ top: start + distance * easeInOut(progress), behavior: 'instant' });

        if (progress < 1) {
            activeFrame = requestAnimationFrame(step);
        } else {
            cleanup();
        }
    };

    for (const type of CANCEL_EVENTS) window.addEventListener(type, cleanup, { passive: true });
    cancelActive = cleanup;
    activeFrame = requestAnimationFrame(step);
}
